export default {
  root: ({ props }) => ({
    class: [
      // Font
      'text-[12px] leading-[150%] tracking-[0.5px] font-normal',

      // Alignments
      'inline-flex items-center justify-center',

      // Spacing
      'px-[6px] py-[3px]' + JSON.stringify(props),
      {
        'text-[12px] xl:text-[14px] py-0 h-auto min-h-[22px] sm:min-h-[26px] xl:min-h-[32px]': props.ptOptions?.size === 'large'
      },

      // Shape
      {
        'rounded': !props.rounded,
        'rounded-full': props.rounded
      },

      // Colors
      'text-white',
      {
        'bg-primary dark:bg-primary': props.severity === null || props.severity === 'primary',
        'bg-surface-900 dark:bg-surface-0': props.severity === 'secondary',
        'bg-lime-600 dark:bg-lime-500': props.severity === 'success',
        'bg-cyan-500 dark:bg-cyan-500': props.severity === 'info',
        'bg-amber-500 dark:bg-amber-500': props.severity === 'warn',
        'bg-red-500 dark:bg-red-500': props.severity === 'danger',
        '!text-surface-900 bg-zinc-200 dark:bg-zinc-200': props.severity === 'lite',
        'bg-zinc-500 dark:bg-zinc-500': props.severity === 'draft',
        'bg-surface-900/40 dark:bg-white-900/400': props.severity === 'overlay'
      }
    ]
  }),
  value: {
    class: 'leading-normal'
  },
  icon: {
    class: 'mr-1 text-sm'
  }
}
